// extracted by mini-css-extract-plugin
export default {"container":"footer_container__-9HhI","menu":"footer_menu__Y+KNw","delimeter":"footer_delimeter__TRL0c","copyright":"footer_copyright__Cp4Fg"};